import { render, staticRenderFns } from "./TravelersList.vue?vue&type=template&id=63933626&scoped=true&"
import script from "./TravelersList.vue?vue&type=script&lang=js&"
export * from "./TravelersList.vue?vue&type=script&lang=js&"
import style0 from "./TravelersList.vue?vue&type=style&index=0&id=63933626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63933626",
  null
  
)

export default component.exports